<template>
  <div class="animated fadeIn">

    <b-card :no-body="true" class="mb-md-0 border-0">
      <b-card-body class="p-0 clearfix">

        <b-row>
          <b-col>

            <!-- input group definition -->
            <b-input-group class="mt-0">

              <!-- icon prefix -->
              <template v-slot:prepend>
                <b-input-group-text>
                  <i :class="['fal',icon,'p-0','text-'+variant]"></i>
                </b-input-group-text>
              </template>

              <!-- select dropdown -->
              <label class="custom-select text-muted" v-if="loading_opts && !disabled">
                <i :class="['fal','fa-spinner','p-0','fa-spin']"></i> Loading...
              </label>

              <b-select v-if="!loading_opts || disabled" v-model="selected_value" :options="options" :disabled="disabled">
                <template v-if="disabled" #first>
                  <b-form-select-option :value="null" disabled>
                    {{ placeholder }}
                  </b-form-select-option>
                </template>
              </b-select>

            </b-input-group>

          </b-col>
        </b-row>

      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import BaseCollection from "../../collections/BaseCollection";

  export default {
    name: 'SelectFilter',
    props: {
      'collection': {
        type: BaseCollection,
        default: null
      },
      'list': {
        type: Array,
        default: null
      },
      'placeholder': {
        type: String,
        default: null
      },
      'textKey': {
        type: String,
        default: null
      },
      'valueKey': {
        type: String,
        default: null
      },
      'selected': {
        type: String,
        default: null
      },
      'icon': {
        type: String,
        default: null
      },
      'variant': {
        type: String,
        default: null
      },
      'filterField': {
        type: String,
        default: null
      },
      'filterOperator': {
        type: String,
        default: null
      },
      'filterLogic': {
        type: String,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        selected_value: this.selected,
        options: [],
        loading_opts: null
      };
    },
    methods: {

      setLoading() {
        this.loading_opts = [{value: null, text: 'Loading...'}];
      },
      clearLoading() {
        this.loading_opts = null;
      },
      setOptsFromCollection() {
        if (!this.collection || !this.collection.models.length) {
          return this.setLoading();
        }
        this.setLoading();
        let options = [{value: null, text: this.placeholder}];
        this.collection.models.forEach((model) => {
          options.push({value: model[this.valueKey], text: model[this.textKey]});
        });
        this.options = options;
        this.clearLoading();
      },
      setOptsFromList() {
        if(!this.list) {
          return this.setLoading();
        }
        let options = [{value: null, text: this.placeholder}];
        this.list.forEach((item) => {
          options.push(item);
        });
        this.options = options;
        this.clearLoading();
      }

    },
    watch: {
      'collection.models': function () {
        this.setOptsFromCollection();
      },
      list: function () {
        this.setOptsFromList();
      },
      selected_value: function () {
        this.$emit('onSelect', {
          field: this.filterField,
          operator: this.filterOperator,
          value: this.selected_value,
          logic: this.filterLogic
        });
      }
    },
    mounted() {
      this.setLoading();
      if(this.list && this.list.length) {
        this.setOptsFromList();
      }
    }
  }
</script>
